import { Column } from "@tanstack/react-table";
import { DebouncedInput } from "../../../common/form-controls/uncontrolled/DebouncedInput";

export const ColumnFilter = ({ column }: { column: Column<any> }) => {
  const columnFilterValue = column.getFilterValue();

  return (
    <DebouncedInput
      type="text"
      onChange={(value) => column.setFilterValue(value)}
      placeholder={"Search"}
      value={(columnFilterValue ?? "") as string}
      style={{ width: column.getSize() }}
      debounce={600}
    />
  );
};
